import { useCallback, useEffect, useState } from "react";
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";


export default function useGetAllTools() {
  const [tools, setTools ] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [retryCount, setRetry] = useState(0);

  const retry = () => {
    setRetry((prev) => ++prev);
  };

  const fetchData = useCallback(
    async () => {
      try {
        const { status, data, error } = await SimpleHttp.get(
          `/api/v1/all/getFrameworks`
        );
        if (status === true) {
          setTools(data);
        } else {
          console.log("Tools Error:", error);
        }
      } catch (error) {
        console.log("Tools Error:", error);
        setError(error);
      }
    
      setLoading(false);
    },
    [],
  )

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [retryCount]);

  return {tools, loading, error, retry };
}
